import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countryCode',
  standalone: false
})
export class CountryCodePipe implements PipeTransform {

  transform(country: string): string {
    return country.split(',')[1].replace(/ /g, '');
  }
}
